<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="editForm" :rules="rules" ref="editForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="姓名">
                <el-input v-model="editForm.elderlyName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="护理套餐" required prop="checkinSetmealCode">
                <el-select v-model="editForm.checkinSetmealCode" placeholder="选择护理套餐" @change="setmealChange" style="width:100%">
                  <el-option
                      v-for="item in setmealList"
                      :key="item.checkinSetmealCode"
                      :label="item.name"
                      :value="item.checkinSetmealCode">
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.univalence }}(元/月)</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="预计入住时间">
                <el-date-picker
                    v-model="editForm.beginTimePlan"
                    type="date"
                    style="width:100%;"
                    value-format="yyyy-MM-dd"
                    placeholder="预计入住时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="预计退住时间">
                <el-date-picker
                    v-model="editForm.endTimePlan"
                    type="date"
                    style="width:100%;"
                    value-format="yyyy-MM-dd"
                    placeholder="预计退住时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>

            <el-col :span="12" class="item">
              <el-form-item label="实际费用" required>
                <el-input v-model="editForm.feiTrue" placeholder="输入实际费用"></el-input>
              </el-form-item>
            </el-col>
          </el-row>


        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Edit',
  props:['setmealList'],
  data() {
    return {

      loading: false,


      datetimerangeValue:'',


      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        elderlyName:'',

        checkinType:'',
        checkinSetmealCode:'',

        type:0,
        beginTimePlan:'',
        endTimePlan:'',
        checkinCode:'',
        chargeType:1,
        feiTrue:0,

      },

      rules:{

        checkinSetmealCode:[
          { required: true, message: '请选择入住套餐', trigger: 'blur' },
        ],

      },


    }
  },

  methods: {
    init(row){
      this.$refs.editForm.resetFields();
      this.editForm.elderlyName=row.elderlyName;
      this.editForm.checkinSetmealCode=row.checkinSetmealCode;
      this.editForm.beginTimePlan = row.beginTimePlan == null?'':row.beginTimePlan;
      this.editForm.endTimePlan = row.endTimePlan == null?'':row.endTimePlan;
      this.editForm.checkinCode=row.checkinCode;
      this.editForm.feiTrue = row.univalenceTrue;

    },

    setmealChange(val){

      //console.log(val);
      for(let i=0;i<this.setmealList.length;i++){
        if(this.setmealList[i].checkinSetmealCode == val){
          this.editForm.feiTrue = this.setmealList[i].univalence;
        }
      }

    },

    closeSelf() {
      this.$emit("closeEdit");
    },

    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Checkin/EditDayCare",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>

<style lang="scss" scoped>

</style>
